import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/metsanomistaja.css'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: 'UA-87257320-2',
  debug: {
    enabled: false
  },
  router
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

document.title = "Metsänkäyttäjä"